import api from "~services/axios";
import { taskHelper } from "http-scheduler/dist/bundle-umd";

const { autoCancel } = taskHelper;

export default {
  // 获取团队
  apiQueryTeam: params => api.get("/api/crmbusiness/queryteam", params),
  apiGetBusiStageList: params =>
    api.get("/api/common/query/category", { params }),

  // 商机列表
  apiGetBusiOpportunityList: params =>
    autoCancel(
      api.post("/api/crmbusiness/query", params),
      () => "business:apiGetBusiOpportunityList",
    ),

  apiSaveAddBusiOpprtunity: params => api.post("/api/crmbusiness/add", params),

  apiGetCustomSelectData: params =>
    api.get("/api/crmbusiness/query/business/customer", { params }),

  apiDeleteBusiOpprtunity: params =>
    api.post("/api/crmbusiness/delete", params),

  apiSaveUpdateBusiOpprtunity: params =>
    api.post("/api/crmbusiness/update", params),

  apiGetBusiOpprtunityDetail: params =>
    api.get("/api/crmbusiness/detail", { params }),

  apiSaveBusiAbolish: params =>
    api.post("/api/crmbusiness/business/frozen", params),

  apiSaveBusiRecover: params =>
    api.post("/api/crmbusiness/business/recovery", params),

  apiGetBusiVisitData: params =>
    api.get("/api/crmbusiness/query/business/visit", { params }),

  apiGetBusiSalesData: params =>
    api.get("/api/crmbusiness/query/business/record", { params }),

  apiGetBusiFileData: params =>
    api.get("/api/crmbusiness/query/business/file", { params }),

  apiDeleteBusiFile: params => api.post("/api/crmbusiness/deletefile", params),

  apiSaveBusiStageChange: params =>
    api.post("/api/crmbusiness/business/stagechange", params),

  apiUploadFile: (params, config) =>
    api.post("/api/crmbusiness/upload", params, config),

  apiBusiOpportunityExport: (params, config) =>
    api.post("/api/crmbusiness/download", params, config),
  // 获取业务员列表
  apiGetBusiSalesList: params =>
    api.get("/api/crmbusiness/query/salesman", { params }),
  // 新增获取联系人列表
  apiGetBusiContactsList: params =>
    api.get("/api/crmbusiness/query/customer/convert", { params }),
  // 详情联系人
  apiGetDetailContactsList: params =>
    api.get("/api/crmbusiness/query/business/convert", { params }),
  // 获取当前业务员不可选业务线接口
  apiGetDisabledBusinessLine: params =>
    api.post("/api/crmbusiness/queryDisabledBusinessLine", params),
  // 商机详情-产品线查询
  apiGetProductLineLine: params =>
    api.get("/api/crmbusiness/query/business/productLine", { params }),
  // 商机详情-产品线添加接口
  addProductLine: params => api.post("/api/crmbusiness/addProductLine", params),
  // 商机详情-产品线编辑接口
  updateProductLine: params =>
    api.post("/api/crmbusiness/updateProductLine", params),
  // 商机详情-产品线删除接口
  deleteProductLine: params =>
    api.post("/api/crmbusiness/deleteProductLine", params),
  // 新增/修改时产品线查询
  queryProductLineList: params =>
    api.post("/api/crmbusiness/queryProductLineList", params),
  // 合同列表获取
  queryContractList: params =>
    api.get("/api/crmbusiness/query/business/contract", { params }),
  // 商机详情-获取阶段提示
  queryStageTip: params =>
    api.get("/api/crmbusiness/queryStageTip", { params }),
  // 商机详情-项目-删除项目
  deleteProject: params =>
    api.post("/api/crmbusiness/business/project/delete", params),
  // 商机详情-项目-获取项目列表
  getProjectData: params =>
    api.get("/api/crmbusiness/query/business/project", { params }),
  addProjectData: params =>
    api.post("/api/crmbusiness/business/project/add", params),
  // 选择已有合同
  contractList: params =>
    api.get("/api/crmbusiness/query/contractList", { params }),
  // 商机关联已有合同保存
  relateContract: params =>
    api.post("/api/crmbusiness/relateContract", params),
  // 客户：选择已有合同
  customerContractList: params =>
    api.get("/api/crmcustomer/query/contractList", { params }),
  // 客户: 关联已有合同保存
  customerRelateContract: params =>
    api.post("/api/crmcustomer/relateContract", params),
};
